import { MeiliSearch } from 'meilisearch'
import { useTranslation } from "react-i18next"

const useMeiliSearch = () => {
  const { i18n } = useTranslation()
  const locale = i18n.language

  const client = new MeiliSearch({
    host: process.env.REACT_APP_MEILI_URL,
    apiKey: process.env.REACT_APP_MEILI_KEY,
  })
  const cities = client.index(`cities_${locale}`)

  return {
    cities,
  }
}

export default useMeiliSearch
